import { ReactComponent as Spinner } from '../../../icons/loader.svg';

import './button.scss';

export const Button = ({
  outline,
  children,
  className,
  onClick,
  type,
  style,
  secondary,
  tertiary,
  loading,
  disabled = false
}) => {
  return (
    <button
      type={type}
      onClick={disabled ? () => {} : onClick}
      style={style}
      className={`button 
      ${secondary ? 'button--secondary' : ''} 
      ${tertiary ? 'button--tertiary' : ''} 
      ${outline ? 'button--outline' : ''} 
      ${disabled ? 'button--disabled' : ''} 
      ${className}`}
    >
      {loading ? <Spinner width={24} height={24} /> : children}
    </button>
  );
};
